/* eslint-disable @typescript-eslint/no-unused-vars */
// import isEmpty from 'lodash-es/isEmpty';
import { TriggersMap, EventsNames } from '../triggers';

export type GTM = any[];
export type DY = { API: any };

function isEmpty(value: any) {
  if (value == null) {
    // null 或 undefined
    return true;
  }

  if (typeof value === 'string' || Array.isArray(value)) {
    // 处理字符串或数组
    return value.length === 0;
  }

  if (typeof value === 'object') {
    // 处理对象
    return Object.keys(value).length === 0;
  }

  // 其他类型（如数字、布尔值）视为非空
  return false;
}

export class DtManager {
  private gtm: GTM;
  private dy: DY;

  constructor() {
    this.gtm = [];
  }

  /**
   * @todo Initialize GTM
   * @description 目前是直接从 window.dataLayer 中获取 GTM，保留此方法以便后续扩展（使用script引入gtm sdk）
   * @returns GTM
   */
  private initGTM() {
    if ((window as any).dataLayer) {
      this.gtm = (window as any).dataLayer;
    }
    return this.gtm;
  }
  private initDYO() {
    if ((window as any).DY) {
      this.dy = (window as any).DY;
    }
    return this.dy;
  }

  /**
   * @description Check if GTM is initialized
   * @returns Promise<GTM>
   */
  private gtmChecker() {
    return new Promise((resolve, reject) => {
      if (isEmpty(this.gtm) && (window as any).dataLayer) {
        resolve(this.gtm);
      } else {
        const gtm = this.initGTM();
        isEmpty(gtm) ? resolve(gtm) : reject();
      }
    });
  }

  /**
   * @description Set or update user_id
   */
  trackUserId(id: string | number) {
    if (!id) {
      throw Error('[DT Error] => User id is required');
    }
    this.gtmChecker().then((gtm) => {
      if (this.gtm) {
        this.gtm.push({
          event: 'setUserId',
          userId: id,
        });
      }
    });
    return true; // Add return statement
  }

  /**
   * @description Track the event
   * @param triggerName `EventsNames[eventName]`, e.g. `EventsNames.EVENT_TRANSACTION`
   * @returns
   */
  track(triggerName: (typeof EventsNames)[keyof typeof EventsNames]) {
    if (!triggerName) {
      throw Error(
        `[DT Error] => Can not find the event name ${triggerName} in the EventsNames. Please check the EventsNames Map.`
      );
    }
    const trigger = TriggersMap[triggerName];
    if (!trigger) {
      throw Error(`[DT Error] => Can not find the trigger for the event ${triggerName}. Please check the TriggersMap.`);
    }
    return (eventData: Record<string, any>) => {
      if (window && (window as any).dataLayer) {
        (window as any).dataLayer.push(trigger(eventData as any));
      } else {
        throw Error('[DT Error] => window.dataLayer is not defined');
      }
    };
  }
  trackDy(triggerName: (typeof EventsNames)[keyof typeof EventsNames]) {
    const trigger = TriggersMap[triggerName];
    return (eventData: Record<string, any>) => {
      if (window && (window as any).DY) {
        (window as any).DY.API('event', trigger(eventData as any));
      } else {
        throw Error('[DT Error] => window.DY is not defined');
      }
    };
  }
}

export default new DtManager();
